import "./Ministries.module.css";
import Header from "@/reusable_sections/Header";
import CategoryFilter from "./sections/CategoryFilter";
import Ministries from "./sections/Ministries";
import EducationMinistries from "./sections/EducationMinistries";
import LeaderResources from "./sections/LeaderResources";
import Youth from "./sections/Youth";
import Ministriesgrid from "./sections/Ministriesgrid";
import Childrenministriesgrid from "./sections/Childrenministriesgrid";
import Footer from "@/reusable_sections/Footer";
export default function MinistriesPage() {
  return <div>
      <Header />
      <CategoryFilter />
      <Ministries />
      <EducationMinistries />
      <LeaderResources />
      <Youth />
      <Ministriesgrid />
      <Childrenministriesgrid />
      <Footer />
    </div>;
}